import React, { useState } from 'react';
import { WIDGET_TYPE_V2, WidgetDetail, WidgetRequestPayload } from '../../../../types/widget';
import ProductWidgetFormWrapper from './ProductWidgetForm';
import BrandWidgetFormWrapper from './BrandWidgetForm';
import EventWidgetFormWrapper from './EventWidgetForm';
import BannerWidgetFormWrapper from './BannerWidgetForm';
import TimedealWidgetFormWrapper from './TimedealWidgetForm';
import { ProductWidgetFormWrapperProps } from './ProductWidgetForm/ProductWidgetFormWrapper';
import { BrandWidgetFormWrapperProps } from './BrandWidgetForm/BrandWidgetFormWrapper';
import { BannerWidgetFormWrapperProps } from './BannerWidgetForm/BannerWidgetFormWrapper';
import { TimedealWidgetFormWrapperProps } from './TimedealWidgetForm/TimedealWidgetFormWrapper';
import { EventWidgetFormWrapperProps } from './EventWidgetForm/EventWidgetFormWrapper';

interface WidgetFormProps {
  isEdit?: boolean;
  initialValue?: WidgetDetail;
  onFinish: (payload: { type: WIDGET_TYPE_V2; widget: WidgetRequestPayload }) => void;
}

const WidgetForm = (props: WidgetFormProps): JSX.Element => {
  const { isEdit = false, initialValue, onFinish } = props;
  const [currentWidgetType, setCurrentWidgetType] = useState<WIDGET_TYPE_V2>(WIDGET_TYPE_V2.PRODUCT);

  const widgetType = initialValue?.type || currentWidgetType;
  const handleFinish = (value: WidgetRequestPayload): void => onFinish({ type: widgetType, widget: value });
  const formProps = { isEdit, initialValue, onChangeType: setCurrentWidgetType, onFinish: handleFinish };

  const widgetFormMap = {
    [WIDGET_TYPE_V2.PRODUCT]: <ProductWidgetFormWrapper {...(formProps as ProductWidgetFormWrapperProps)} />,
    [WIDGET_TYPE_V2.BRAND]: <BrandWidgetFormWrapper {...(formProps as BrandWidgetFormWrapperProps)} />,
    [WIDGET_TYPE_V2.EVENT]: <EventWidgetFormWrapper {...(formProps as EventWidgetFormWrapperProps)} />,
    [WIDGET_TYPE_V2.BANNER]: <BannerWidgetFormWrapper {...(formProps as BannerWidgetFormWrapperProps)} />,
    [WIDGET_TYPE_V2.TIMEDEAL]: <TimedealWidgetFormWrapper {...(formProps as TimedealWidgetFormWrapperProps)} />,
  };

  return widgetFormMap[widgetType];
};

export default WidgetForm;
